import { FormattedMessage } from 'react-intl'

import { IconSolutionBetSizes } from '@gto/ui/assets'
import {
  CircleStackIcon,
  LinkIcon,
  MagnifyingGlassIcon,
  ShoppingCartIcon,
} from '@gto/ui/icons/outline'
import { Typography } from '@gto/ui/typography'

import rewardsImg from '@/assets/images/rewards-bg.webp'
import { ImageWithPlaceholder } from '@/components/image-with-placeholder'

import type { HowToItem } from './promo-how-to-card'
import { PromoHowToCard } from './promo-how-to-card'

export const PromoHowToSection = () => {
  const getGridArea = (index: number) => {
    switch (index) {
      case 0:
        return '1 / 1 / 2 / 2'
      case 1:
        return '2 / 1 / 3 / 2'
      case 2:
        return '3 / 1 / 4 / 2'
      case 3:
        return '1 / 2 / 4 / 3'
      case 4:
        return '4 / 1 / 5 / 3'
      default:
        return 'auto'
    }
  }

  return (
    <section className="flex flex-col gap-8">
      <Typography
        className="text-center"
        variant="h4"
      >
        <FormattedMessage id="promo.howTo.title" />
      </Typography>

      <div className="grid grid-cols-2 grid-rows-4 gap-8 sm:grid-cols-1 sm:grid-rows-[repeat(5,auto)]">
        {howToMap.map((howTo, index, arr) => (
          <div
            // eslint-disable-next-line @eslint-react/no-array-index-key -- fixed how-to steps literal, never reorders
            key={index}
            className="sm:[grid-area:auto]"
            style={{ gridArea: getGridArea(index) }}
          >
            <PromoHowToCard
              {...howTo}
              placement={index === arr.length - 1 ? 'center' : 'left'}
            />
          </div>
        ))}
      </div>
    </section>
  )
}

const howToMap: HowToItem[] = [
  {
    icon: MagnifyingGlassIcon,
    title: 'promo.howTo.step.1.title',
    description: 'promo.howTo.step.1.description',
    order: 1,
  },
  {
    icon: LinkIcon,
    title: 'promo.howTo.step.2.title',
    description: 'promo.howTo.step.2.description',
    order: 2,
  },
  {
    icon: CircleStackIcon,
    title: 'promo.howTo.step.3.title',
    description: 'promo.howTo.step.3.description',
    order: 3,
  },
  {
    icon: IconSolutionBetSizes,
    title: 'promo.howTo.step.4.title',
    description: 'promo.howTo.step.4.description',
    order: 4,
    children: (
      <ImageWithPlaceholder
        alt="Rewards Page Summary Screenshot"
        src={rewardsImg}
      />
    ),
  },
  {
    icon: ShoppingCartIcon,
    title: 'promo.howTo.step.5.title',
    description: 'promo.howTo.step.5.description',
    order: 5,
  },
]
